import moment from 'moment';
import React from 'react'
import Pagination from './TablePagination'
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';


const UiTable = ({ actionHandler, allData, DetailHandler, totalCount, paginationHandler, paginationHandlerNew,
    pageNumber, noOfRows, sorting, markAsImportant, tableType,handleSwitchChange={} }) => {
    let rolesData = window.sessionStorage.getItem('rolesData');

    return (
        <div className='table-responsive full-height'>
            {allData.length > 0 ?
                <>
                    <div style={{ overflowX: 'auto' }}>
                        <table className='table credhub-table'>
                            <thead>
                                {
                                    tableType === "dealerTable" ?
                                        <tr>
                                            <th scope="col">Info</th>
                                            <th scope='col'>Mark Important</th>
                                            {/* <th scope="col" style={{ cursor: 'pointer' }} onClick={(e) => sorting("firmName")}>
                                                <span>Firm Name</span>
                                                <i className='fa fa-sort table-sort' />
                                            </th> */}
                                            <th scope="col">HUB Name</th>
                                            <th scope="col">HUB Manager</th>
                                            <th scope="col">Urja Agent</th>
                                            <th scope="col" style={{ cursor: 'pointer' }} onClick={(e) => sorting("name")}>Name  <i className='fa fa-sort table-sort' /></th>
                                            <th scope="col">Community Code</th>
                                            <th scope="col">Email Id</th>
                                            <th scope="col">Mobile Number</th>
                                            <th scope="col">Created At</th>
                                            {/* {
                                        rolesData && rolesData.includes("adminCommunityCreateAndEdit") ? */}
                                            <th scope="col">Active</th>
                                            <th scope="col">Edit</th>
                                            {/* : ""} */}
                                        </tr>
                                        : ''}
                                {
                                    tableType === "salesAgentTable" ?
                                        <tr>
                                            <th scope="col">Info</th>
                                            <th scope='col'>Mark Important</th>
                                        
                                            <th scope="col">Community Code</th>
                                            <th scope="col" style={{ cursor: 'pointer' }} onClick={(e) => sorting("name")}>Name  <i className='fa fa-sort table-sort' /></th>
                                            {/* <th scope="col">Community Type</th> */}
                                            <th scope="col">Hub Name</th>
                                            <th scope="col">Hub Manager</th>
                                            <th scope="col">Email Id</th>
                                            <th scope="col">Mobile Number</th>
                                            <th scope="col">Created At</th>
                                            {/* {
                                        rolesData && rolesData.includes("adminCommunityCreateAndEdit") ? */}
                                            <th scope="col">Edit</th>
                                            {/* : ""} */}
                                        </tr>
                                        : ''}
                            </thead>
                            <tbody>
                                {allData.map((row, i) => {
                                    return (
                                        <>
                                            {
                                                tableType === "dealerTable" ?
                                                    <tr key={i}>
                                                        <td>
                                                            <i className='fa fa-info-circle' onClick={e => DetailHandler(row)} />
                                                        </td>
                                                        <td><i className={row.important === true ? 'fa fa-star pointer colorYellow' : 'fa fa-star pointer colorGray'} style={{ color: row.important === true ? '#ffbd11' : "#8f8f8f" }} onClick={e => markAsImportant(row.communityId, row.important)}></i></td>
                                                        {/* <td>{row.firmName}</td> */}
                                                        <td>{row.hubName}</td>
                                                        <td>{row.hubManagerName}</td>
                                                        <td>{row.parentCommunityMemberName}</td>
                                                        <td>{row.communityName}</td>
                                                        <td>{row.communityCode}</td>
                                                        <td>{row.email}</td>
                                                        <td>{row.mobileNo}</td>
                                                        <td>{row.createdOn ? moment(row.createdOn).format("DD MMM YYYY") : ""} </td>
                                                        <td >
                                                          
                                                            <AntSwitch  inputProps={{ 'aria-label': 'ant design' }}  checked={row.active == true}
                                                            onChange={() => handleSwitchChange(row, row.active)}
                                                            />
                                                           
                                                        </td>

                                                        {/* {
                                                rolesData && rolesData.includes("adminCommunityCreateAndEdit") ? */}
                                                        <td>
                                                            <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                <i className='fa fa-edit' />
                                                            </button>
                                                            <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                                <i className='fa fa-trash-o' />
                                                            </button>
                                                        </td>
                                                        {/* : ""} */}
                                                    </tr>
                                                    : ''}
                                            {
                                                tableType === "salesAgentTable" ?
                                                    <tr key={i}>
                                                        <td>
                                                            <i className='fa fa-info-circle' onClick={e => DetailHandler(row)} />
                                                        </td>
                                                        <td><i className={row.important === true ? 'fa fa-star pointer colorYellow' : 'fa fa-star pointer colorGray'} style={{ color: row.important === true ? '#ffbd11' : "#8f8f8f" }} onClick={e => markAsImportant(row.communityId, row.important)}></i></td>
                                                        <td>{row.communityCode}</td>
                                                        <td>{row.communityName}</td>
                                                        {/* <td>{row.communityType}</td> */}
                                                        <td>{row.hubName}</td>
                                                        <td>{row.hubManagerName}</td>
                                                        <td>{row.email}</td>
                                                        <td>{row.mobileNo}</td>
                                                        <td>{row.createdOn ? moment(row.createdOn).format("DD MMM YYYY") : ""} </td>

                                                        {/* {
                                                rolesData && rolesData.includes("adminCommunityCreateAndEdit") ? */}
                                                        <td>
                                                            <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                <i className='fa fa-edit' />
                                                            </button>
                                                            <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                                <i className='fa fa-trash-o' />
                                                            </button>
                                                        </td>
                                                        {/* : ""} */}
                                                    </tr>
                                                    : ''}
                                        </>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <Pagination

                        paginationHandlerNew={paginationHandlerNew}
                        totalCount={totalCount}
                        paginationHandler={paginationHandler}
                        pageNumber={pageNumber}
                        noOfRows={noOfRows}
                    />
                </>
                : null}
        </div>
    )
}

export default UiTable;

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  margin:"auto",
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#1890ff',
        ...theme.applyStyles('dark', {
          backgroundColor: '#177ddc',
        }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
    ...theme.applyStyles('dark', {
      backgroundColor: 'rgba(255,255,255,.35)',
    }),
  },
}));